import { PropsWithChildren } from "react";

import { useClientApplicationTabsDataQuery } from "./ClientApplicationTabs.g";

import { Tabs } from "@design-system/Tabs/Tabs";

import { routes } from "@pages/routes";

type Props = PropsWithChildren<{
  clientId: string;
  clientApplicationId: string;
}>;

export const ClientApplicationTabs = ({
  clientId,
  clientApplicationId,
}: Props) => {
  const { data } = useClientApplicationTabsDataQuery({
    clientApplicationId,
  });

  const unresolvedNotificationsCount =
    data?.resourceGroupNotifications?.totalCount || 0;

  return (
    <Tabs style={{ borderBottom: "none", gap: "24px" }}>
      <Tabs.Tab
        name="Dashboard"
        to={routes.portal.clients.client.applications.application.dashboard.$buildPath(
          {
            params: { clientId, applicationId: clientApplicationId },
          },
        )}
      />
      <Tabs.Tab
        name="Unresolved notifications"
        to={routes.portal.clients.client.applications.application.notifications.$buildPath(
          {
            params: { clientId, applicationId: clientApplicationId },
          },
        )}
        bubbleCount={unresolvedNotificationsCount}
      />
      <Tabs.Tab
        name="File uploads"
        to={routes.portal.clients.client.applications.application.fileUploads.$buildPath(
          {
            params: { clientId, applicationId: clientApplicationId },
          },
        )}
      />
      <Tabs.Tab
        name="Shared credentials"
        to={routes.portal.clients.client.applications.application.sharedCredentials.$buildPath(
          {
            params: { clientId, applicationId: clientApplicationId },
          },
        )}
      />
      <Tabs.Tab
        name="All Users"
        to={routes.portal.clients.client.applications.application.users.$buildPath(
          {
            params: { clientId, applicationId: clientApplicationId },
          },
        )}
      />
      <Tabs.Tab
        name="Record"
        to={routes.portal.clients.client.applications.application.record.$buildPath(
          {
            params: { clientId, applicationId: clientApplicationId },
          },
        )}
      />
    </Tabs>
  );
};
